import { FC, MouseEvent, ReactNode } from 'react';
import { Tooltip } from '@mui/material';
import IconButton from '@/components/@extended/IconButton';
import { ColorProps } from '@/theme/types/extended';

interface ITableActionButtonProps {
	title: string;
	color?: ColorProps;
	// Evenimentul e opțional în handler — necesar acțiunilor cu meniu (ancora ⋮).
	onClick?: (event: MouseEvent<HTMLElement>) => void;
	disabled?: boolean;
	children: ReactNode;
}

// Standard table action button: 30x30 light-tinted square, 12px icon, semantic color.
export const TableActionButton: FC<ITableActionButtonProps> = ({
	title,
	color = 'secondary',
	onClick,
	disabled = false,
	children
}) => (
	<Tooltip title={title}>
		<span>
			<IconButton
				variant="text"
				color={color}
				onClick={onClick}
				disabled={disabled}
				sx={{
					width: 36,
					height: 36,
					minWidth: 36,
					p: 0,
					// transparent at rest, faint tint on hover (matches template tables)
					backgroundColor: 'transparent',
					'& .MuiSvgIcon-root': { fontSize: 16 },
					'& .anticon': { fontSize: 16 },
					'& svg': { fontSize: 16 },
					// disabled → fără fundal/bordură (doar iconița estompată)
					'&.Mui-disabled': {
						backgroundColor: 'transparent',
						border: 'none'
					}
				}}
			>
				{children}
			</IconButton>
		</span>
	</Tooltip>
);

TableActionButton.defaultProps = {
	color: 'secondary',
	onClick: undefined,
	disabled: false
};
